import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { IPhotographerInvoiceCollection } from './MultiplePhotographersInvoiceTypes';
import { Row, Col } from 'react-bootstrap';

interface IProps {
    invoiceCollection: IPhotographerInvoiceCollection;
    key: number;
    anyRejections: boolean;
    anyUnhandled: boolean;
    view: (collection: IPhotographerInvoiceCollection) => void;
    canCreateFile: boolean;
    download: (collection: IPhotographerInvoiceCollection) => void;
    downloadV2: (collection: IPhotographerInvoiceCollection) => void;
}

const InvoiceCollectionListRow = (props: IProps) => {
    return (
        <Row>
            <Col sm={12} md={6}>
                <a onClick={() => props.view(props.invoiceCollection)} className="alink">
                    {props.invoiceCollection.name}
                </a>
            </Col>

            {props.anyRejections && (
                <Col sm={4} md={2}>
                    <span className="status-icons">
                        <i
                            title={Translate(
                                'photographer-invoice-collections/list/rejection-marker/title'
                            )}
                            className="material-icons color-body color-danger-bg"
                        >
                            cancel
                        </i>
                    </span>
                </Col>
            )}
            {props.anyUnhandled && (
                <Col sm={4} md={2}>
                    <span className="status-icons">
                        <i
                            title={Translate(
                                'photographer-invoice-collections/list/unhandled-marker/title'
                            )}
                            className="material-icons color-body color-warning-bg"
                        >
                            notifications
                        </i>
                    </span>
                </Col>
            )}

            {props.canCreateFile && (
                <Col sm={8} md={4}>
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <a onClick={() => props.download(props.invoiceCollection)} className="alink">
                            {Translate(
                                'photographer-invoice-collections/lists/history/payment-file/download'
                            )}
                        </a>

                        <a onClick={() => props.downloadV2(props.invoiceCollection)} className="alink" style={{ marginLeft: '10px' }}>
                            &nbsp;&nbsp;&nbsp;-v2-&nbsp;&nbsp;&nbsp;
                        </a>
                    </span>
                </Col>
            )}
        </Row>
    );
};

export default InvoiceCollectionListRow;
